var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex justify-start",attrs:{"outlined":"","tile":""}},[_c('v-select',{staticClass:"pl-3 pr-3",attrs:{"items":_vm.wsTypesItems,"item-text":"FT_NAME","item-value":"FT_ID","value":_vm.value,"readonly":_vm.readonly,"label":"Тип конфигурации","no-data-text":"Нет данных"},on:{"input":_vm.setValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }